import { useTranslation } from "react-i18next";
import { useSelector, shallowEqual } from "react-redux";
import AskValue from "../global/BidAsk/AskValue";
import BidValue from "../global/BidAsk/BidValue";
import React, { useEffect } from "react";
import ProfitLoss from "../global/BidAsk/ProfitLoss";
import moment from "moment/moment";


const defaultRender = (value) => (value ? value : "--");

const formatDateTime = (dateTime) => {
  return moment(dateTime).format('DD-MM-YYYY HH:mm:ss');
};
const formatPrice = (value, decimalPlaces) => {
  if (value === null || value === undefined) return "";
  return Number(value)?.toFixed(decimalPlaces);
};


const useTradeCell = (handleCloseClick) => {
  const { t } = useTranslation();
  const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);
  const orderSLTP = useSelector((state) => state.orderPosition.orderSLTP, shallowEqual);
  const profitLossData = useSelector((state) => state.profitLoss.profitLossData);


  return React.useMemo(() => ([
    { title: t("ticket"), width: 70, dataIndex: "id", render: defaultRender },
    { title: t("date/time"), width: 150, dataIndex: "dateTime", render: (value) => formatDateTime(value) },
    { title: t("type"), width: 70, dataIndex: "side", render: (value, row) => row.side == 1 ? <span className="green">BUY</span> : <span className="red">SELL</span> },
    { title: t("symbol"), width: 100, dataIndex: "symbolName", render: defaultRender },
    { title: t("openPrice"), width: 100, dataIndex: "openPrice", render: defaultRender },
    {
      title: t('s/l'), width: 100, dataIndex: 'stopLoss',
      render: (value, row) => {
        const sltp = orderSLTP.find((sltp) => sltp.positionId === row.id);
        return sltp ? sltp.stopLoss : defaultRender(value);
      }
    },
    {
      title: t('t/p'), width: 100, dataIndex: 'takeProfit',
      render: (value, row) => {
        const sltp = orderSLTP.find((sltp) => sltp.positionId === row.id);
        return sltp ? sltp.takeProfit : defaultRender(value);
      }
    },

    // { title: t("currentPrice"),width:100, dataIndex: "currentPrice", render: (value, row) => formatPrice(value, decimalPlaces) },
    {
      title: t("currentPrice"), width: 120, dataIndex: "currentPrice", render: (value, row) => row?.side == -1 ? <AskValue symbolId={row.symbolId} digits={decimalPlaces} /> : <BidValue symbolId={row.symbolId} digits={decimalPlaces} />
    },
    { title: t("commission"), width: 100, dataIndex: "commission", render: defaultRender },
    // { title: t("profit"),width:100, dataIndex: "profit", render: (value,row) => <ProfitLoss row={row} /> },
    { title: t("profit"), width: 100, dataIndex: "profit", render: (value, row) => <ProfitLoss row={{ ...row, profit: profitLossData[row.id] ?? value }} /> },

    { title: t("amount"), width: 100, dataIndex: "amount", render: (value) => formatPrice(value, decimalPlaces) },
    { title: t("comment"), width: 100, dataIndex: "comment", render: defaultRender },
  ]), [orderSLTP, decimalPlaces, t]);
};

export default useTradeCell;
